module.exports = __webpack_public_path__ + "media/images/admin/icons/maximize-a19fddf606666899fbe127b0ed8377e9.svg";